"use strict";
//import { Account, Connection, Near } from "near-api-js";
//import { KeyStore } from "near-api-js/lib/key_stores";
//import { KeyPair } from "near-api-js/lib/utils";
Object.defineProperty(exports, "__esModule", { value: true });
